import React, { useEffect } from "react";
import styles from "./actionBar.scss";
import FavoriteButton from "../../FavoriteButton";
import PhoneNumberButton from "../AdDetailsPageWeb/PhoneNumberButton";
import { EmailIcon } from "./EmailIcon";
import { PhoneIcon } from "./PhoneIcon";
import { FavoriteIcon } from "./FavoriteIcon";
import { UserI } from "../../../typings/interfaces";

const ACTION_BAR_ID = "actionBarId";

export interface ActionBarProps {
  adDetails: any;
  hasPhones: boolean;
  isMobile: boolean;
  onChatClick?: () => void;
  onCallPhoneClick?: () => void;
  user: UserI
}

const ActionBar = (props: ActionBarProps) => {
  const {
    adDetails,
    hasPhones,
    isMobile,
    onChatClick,
    onCallPhoneClick,
    user,
  } = props;

  useEffect(() => {
    const handleScroll = event => {
      const actionBar = document.getElementById(ACTION_BAR_ID);

      if (!actionBar) {
        return;
      }

      if (document.body.scrollTop > 160 || document.documentElement.scrollTop > 160) {
        actionBar.style.display = "flex";
      } else {
        actionBar.style.display = "";
      }
    }

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    }
  }, []);

  const adDetailsCreatorId = adDetails && adDetails.creator && adDetails.creator.id

  const shouldShowMessageButton = user ? adDetailsCreatorId !== user.userId : true;

  return (
    <div className={styles.container}>
      <div
        className={styles.bar} id={ACTION_BAR_ID}
        style={!hasPhones && !isMobile ? { width: "260px" } : {}}
      >
        {shouldShowMessageButton && <div className={styles.item}>
          <span
            role="button"
            tabIndex={0}
            onClick={onChatClick}
            className={styles.button}
          >
            <EmailIcon />
            <span className={styles.text}>
              Piši
            </span>
          </span>
        </div>}

        {hasPhones ? (
          <div className={styles.item}>
            {isMobile ? (
              <span
                role="button"
                tabIndex={0}
                onClick={onCallPhoneClick}
                className={styles.button}
              >
                <PhoneIcon />
                <span className={styles.text}>
                  {"Nazovi"}
                </span>
              </span>
            ) : (
                <PhoneNumberButton
                  hasPhones={hasPhones}
                  category={adDetails.category}
                  adId={adDetails.summary.id}
                  button={(props) => {
                  const {
                    onClick,
                    number
                  } = props;

                  return (
                    <span
                      role="button"
                      tabIndex={0}
                      className={styles.button}
                      onClick={onClick}
                    >
                      {!number && <PhoneIcon />}
                      <span
                        className={styles.text}
                        style={number ? { fontWeight: 600 } : {}}
                      >
                        {number ? number : "Nazovi"}
                      </span>
                    </span>
                  );
                }} />
              )}
          </div>
        ) : null}

        <div className={styles.item}>
          <FavoriteButton
            //disabled={disabled} TODO: add disabled ?????
            category={adDetails.category}
            flag="SpecialSection"
            component={FavoriteIcon}
            ad={adDetails.summary}
            adLists={{ detail: { data: [adDetails.summary] } }}
          />
        </div>
      </div>
    </div>
  );
};

export default ActionBar;



// WEBPACK FOOTER //
// ./src/containers/AdDetailsPage/ActionBar/index.tsx